import React from "react";
import { Navigate } from "react-router-dom";
import { PageHeader } from "@finitless/shared/components";
import { useTranslation } from "react-i18next";
import { useToast } from "@finitless/shared/hooks";
import { isWhiteLabel } from "@finitless/shared/lib";
import {
  useDashboardSite,
  useActivateDashboardSite,
} from "../../../../hooks/useWhiteLabel";
import { useWhiteLabelSiteSocket } from "../../../../hooks/useWhiteLabelSiteSocket";
import DomainCard from "./DomainCard";
import BrandingCard from "./BrandingCard";

const WhiteLabelPage = ({ selectedBrand }) => {
  const { t } = useTranslation("whiteLabel");
  const toast = useToast();
  const { data: site, isLoading } = useDashboardSite();
  const activate = useActivateDashboardSite();

  useWhiteLabelSiteSocket(site);

  const handleActivate = async () => {
    try {
      await activate.mutateAsync();
    } catch {
      toast.error(t("activate.error"));
    }
  };

  if (isWhiteLabel()) {
    return <Navigate to="/overview" replace />;
  }

  return (
    <div>
      <PageHeader
        title={t("header.title")}
        subtitle={t("header.subtitle")}
        selectedBrand={selectedBrand}
      />

      <div className="space-y-6">
        {isLoading ? (
          <div data-testid="white-label-skeleton" className="space-y-6">
            <div className="h-40 animate-pulse rounded-lg bg-gray-800" />
            <div className="h-40 animate-pulse rounded-lg bg-gray-800" />
          </div>
        ) : !site ? (
          <div className="rounded-lg border border-gray-700 bg-gray-800 p-8 text-center">
            <h3 className="mb-2 text-xl font-medium text-white">
              {t("activate.title")}
            </h3>
            <p className="mx-auto mb-6 max-w-md text-gray-400">
              {t("activate.description")}
            </p>
            <button
              onClick={handleActivate}
              disabled={activate.isPending}
              className="rounded-lg bg-blue-600 px-6 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:bg-gray-600"
            >
              {activate.isPending
                ? t("activate.activating")
                : t("activate.button")}
            </button>
          </div>
        ) : (
          <div className="space-y-6">
            <DomainCard site={site} />
            <BrandingCard />
          </div>
        )}
      </div>
    </div>
  );
};

export default WhiteLabelPage;
